import React, { useEffect, useState } from 'react';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import PortfolioCard from './PortfolioCard';



export default function Pageload(props){
    const [display,setDisplay]=useState(false);

    useEffect(()=>{
        setDisplay(true);
        setTimeout(()=>{
            setDisplay(false);
        },5000)
    },[])

    return(
    <div>
        {display ? 
            <Loader
                type="Puff"
                color="#00BFFF"
                height={200}
                width={200}
                display={display}
                style={{
                    background:'#000000',
                    height:'100vh',
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center'
                }}
            />
            :
            <PortfolioCard />
    }
     </div>
    )
}